(() => {
  'use strict';
  const configNode = document.getElementById('hk-bf-config');
  if (!configNode || customElements.get('hk-cart-rewards')) return;
  const config = JSON.parse(configNode.textContent);
  const labels = config.labels;
  const [head, car, quad] = config.products;
  const packs = config.products;
  const root = window.Shopify.routes.root;
  const productIds = new Set(packs.map(pack => String(pack.id)));
  const checkoutPass = new WeakSet();
  let queue = Promise.resolve();
  let jobs = 0;
  let pendingChoice = false;
  let blockedAt = '';
  let notice = '';
  let catalogPromise;
  let componentNumber = 0;

  function active() {
    return config.active && Date.now() < config.ends;
  }
  function money(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'fi', {
      style: 'currency', currency, minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2
    }).format(cents / 100);
  }
  function inspect(cart) {
    const gifts = cart.items.filter(item => productIds.has(String(item.product_id)));
    const paid = Math.max(0, cart.total_price - gifts.reduce((n, item) => n + item.final_line_price, 0));
    const rate = cart.currency === 'EUR' ? 1 : Number(window.Shopify.currency?.rate);
    const limits = rate > 0 ? [6000, 8000, 12000].map(n => Math.ceil(n * rate - 0.000001)) : [];
    const first = gifts[0];
    const key = JSON.stringify([cart.currency, paid, cart.items.filter(i => !productIds.has(String(i.product_id))).map(i => [i.variant_id, i.quantity, i.final_line_price])]);
    return { gifts, paid, limits, first, key, skip: cart.attributes?.hk_bf_skip_26 === 'yes',
      free: gifts.length === 1 && first.quantity === 1 && first.final_line_price === 0 };
  }
  function choices(pack) {
    return pack.variants.filter(v => v.available);
  }
  function loadCatalog() {
    if (!catalogPromise) {
      catalogPromise = Promise.all(packs.filter(p => !p.variants.length).map(async pack => {
        try {
          const response = await fetch(root + 'products/' + encodeURIComponent(pack.handle) + '.js');
          if (response.ok) {
            const product = await response.json();
            pack.variants = product.variants.map(v => ({...v, image: v.featured_image?.src || product.featured_image}));
          }
        } catch { /* Only available gifts can be selected. */ }
      }));
    }
    return catalogPromise;
  }
  async function cartRequest(path, body) {
    const options = { cache: 'no-store', headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    const response = await fetch(root + path, options);
    if (!response.ok) throw new Error(labels.error);
    return response.json();
  }
  function desired(cart, state, action, selected) {
    if (!active() || action === 'remove' || (state.skip && action !== 'claim' && action !== 'pick')) return 0;
    const { first, paid, limits } = state;
    if (!limits.length) {
      if (action === 'pick') return selected;
      if (action === 'claim') return choices(head)[0]?.id || 0;
      return state.free ? first.variant_id : 0;
    }
    if (paid < limits[0]) return 0;
    if (action === 'pick' && paid >= limits[2]) return selected;
    if (first && String(first.product_id) !== String(head.id) && paid >= limits[2]) return first.variant_id;
    if (first && String(first.product_id) === String(head.id)) return first.variant_id;
    if (blockedAt === state.key && action !== 'claim' && action !== 'pick') return 0;
    return choices(head)[0]?.id || 0;
  }
  function updatesFor(lines, wanted) {
    const updates = {};
    let found = false;
    for (const item of lines) {
      const keep = !found && Number(item.variant_id) === Number(wanted);
      const quantity = keep ? 1 : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
      if (keep) found = true;
    }
    if (wanted && !found) updates[String(wanted)] = 1;
    return updates;
  }
  async function refresh(cart) {
    const drawer = document.getElementById('cart-drawer');
    const items = document.querySelector('#cart cart-items');
    if (items && !cart.item_count) { location.reload(); return; }
    if (items?.refresh) await items.refresh();
    if (drawer?.refresh) await drawer.refresh(true);
    document.dispatchEvent(new CustomEvent('on:css-var-height:update'));
  }
  function report(key) {
    notice = key;
    document.querySelectorAll('hk-cart-rewards').forEach(panel => panel.showNotice());
    if (!document.querySelector('hk-cart-rewards') && key) {
      const el = document.getElementById('cart-errors');
      if (el) { el.textContent = labels[key]; el.hidden = false; }
    }
  }
  async function reconcile(action, selected) {
    await loadCatalog();
    let cart = await cartRequest('cart.js');
    let state = inspect(cart);
    const hadPaidGift = state.gifts.some(i => i.final_line_price > 0);
    const wanted = desired(cart, state, action, selected);
    const updates = updatesFor(state.gifts, wanted);
    const attributes = {};
    if (action === 'remove') attributes.hk_bf_skip_26 = 'yes';
    if (action === 'claim' || action === 'pick') attributes.hk_bf_skip_26 = '';
    let dirty = Object.keys(updates).length > 0 || Object.keys(attributes).length > 0;
    if (dirty) {
      cart = await cartRequest('cart/update.js', { updates, attributes });
      state = inspect(cart);
    }
    let refused = false;
    if (state.gifts.length && (!state.free || !active() || Number(state.first.variant_id) !== Number(wanted))) {
      blockedAt = state.key;
      cart = await cartRequest('cart/update.js', { updates: updatesFor(state.gifts, 0) });
      if (inspect(cart).gifts.length) throw new Error(labels.error);
      dirty = true;
      refused = true;
    }
    if (wanted && !inspect(cart).gifts.length) {
      blockedAt = inspect(cart).key;
      refused = true;
    }
    if (refused) report('blocked');
    else if (action !== 'sync' || dirty) report('');
    if (dirty) {
      pendingChoice = false;
      await refresh(cart);
    }
    if (action === 'checkout' && (refused || hadPaidGift)) {
      report(refused ? 'blocked' : 'repair');
      return false;
    }
    return true;
  }
  function run(action, variant = 0) {
    if (action === 'sync' && jobs) return queue;
    jobs++;
    const result = queue.then(() => reconcile(action, variant)).catch(() => {
      report('error');
      return false;
    }).finally(() => { jobs--; });
    queue = result;
    return result;
  }

  class Rewards extends HTMLElement {
    connectedCallback() {
      this.snap = JSON.parse(this.querySelector('.hk-snapshot').textContent);
      if (notice === 'busy') notice = '';
      const {first} = inspect(this.snap);
      this.chosenModel = first && String(first.product_id) === String(quad.id) ? 'quad' : 'car';
      this.colourId = first && String(first.product_id) === String(car.id) ? String(first.variant_id) : '';
      const group = 'hk-free-model-' + (++componentNumber);
      this.querySelectorAll('[data-radio]').forEach(radio => { radio.name = group; });
      this.onchange = event => {
        if (event.target.matches('[data-radio]')) this.chosenModel = event.target.value;
        else if (event.target.matches('[data-colour]')) {
          this.chosenModel = 'car';
          this.colourId = event.target.value;
        } else return;
        this.paintPicker();
      };
      this.onclick = event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button) || button.disabled) return;
        if (button.hasAttribute('data-switch')) {
          pendingChoice = !pendingChoice;
          this.paint();
        } else if (button.hasAttribute('data-claim')) {
          run('claim');
        } else if (button.hasAttribute('data-confirm')) {
          const variant = this.chosenModel === 'car'
            ? choices(car).find(v => String(v.id) === this.colourId) : choices(quad)[0];
          if (variant) {
            button.disabled = true;
            button.textContent = labels.busy;
            run('pick', variant.id).finally(() => {
              if (this.isConnected) this.paint();
            });
          }
        }
      };
      loadCatalog().then(() => {
        if (!this.isConnected) return;
        this.paint();
        const state = inspect(this.snap);
        const wanted = desired(this.snap, state, 'sync', 0);
        if ((!state.free && state.gifts.length) || Object.keys(updatesFor(state.gifts, wanted)).length) run('sync');
      });
    }
    showNotice() {
      const el = this.querySelector('[data-notice]');
      el.textContent = notice ? labels[notice] : '';
      el.hidden = !notice;
    }
    paintPicker() {
      const colours = choices(car);
      const flyers = choices(quad);
      if (this.chosenModel === 'car' && !colours.length && flyers.length) this.chosenModel = 'quad';
      if (this.chosenModel === 'quad' && !flyers.length && colours.length) this.chosenModel = 'car';
      const colour = colours.find(v => String(v.id) === this.colourId) || colours[0];
      this.colourId = colour ? String(colour.id) : '';
      const select = this.querySelector('[data-colour]');
      if (!select.options.length && colours.length) {
        select.replaceChildren(...colours.map(v => new Option(v.title, String(v.id))));
      }
      select.value = this.colourId;
      this.querySelector('[data-colour-field]').hidden = this.chosenModel !== 'car' || !colours.length;
      for (const [kind, variant] of [['car', colour], ['quad', flyers[0]]]) {
        const card = this.querySelector('[data-choice="' + kind + '"]');
        const radio = card.querySelector('input');
        radio.disabled = !variant;
        radio.checked = Boolean(variant && this.chosenModel === kind);
        card.querySelector('[data-stock]').hidden = Boolean(variant);
        const img = card.querySelector('[data-gift-image]');
        if (variant?.image && img.getAttribute('src') !== variant.image) {
          img.removeAttribute('srcset');
          img.src = variant.image;
          img.hidden = false;
        }
      }
      const button = this.querySelector('[data-confirm]');
      const {first, free} = inspect(this.snap);
      const alreadyPicked = free && String(first.product_id) !== String(head.id);
      button.disabled = !colours.length && !flyers.length;
      button.textContent = button.disabled ? labels.none : alreadyPicked ? labels.save_choice
        : this.chosenModel === 'car' ? labels.confirm_car : labels.confirm_quad;
    }
    paint() {
      if (!active()) { this.hidden = true; return; }
      const {paid, limits, first, free, skip, key} = inspect(this.snap);
      const currency = this.snap.currency;
      const full = free && String(first.product_id) !== String(head.id);
      const known = limits.length > 0;
      const unlock = known && paid >= limits[0];
      const unlockTop = known && paid >= limits[2];
      const next = !unlock ? 0 : config.shipping && paid < limits[1] ? 1 : 2;
      const progress = known ? Math.min(100, (paid / limits[2]) * 100) : 0;
      this.querySelector('[data-fill]').style.setProperty('--fill', progress + '%');
      const anyToy = choices(car).length + choices(quad).length > 0;
      const nextMessage = known ? labels[['to_head','to_shipping','to_second'][next]].replace('[amount]',money(Math.max(limits[next]-paid,0),currency)) : labels.check_at_checkout;
      this.querySelector('[data-message]').textContent = full ? (pendingChoice ? labels.choose : labels.chosen)
        : unlockTop ? (anyToy ? labels.choose : labels.none) : nextMessage;
      for (const [index, stage] of ['head','shipping','second'].entries()) {
        const el = this.querySelector('[data-step="' + stage + '"]');
        if (stage === 'shipping' && !config.shipping) { el.hidden = true; continue; }
        const reached = known && paid >= limits[index];
        const inCart = stage === 'head' ? free : stage === 'second' && full;
        const earned = inCart || (stage === 'shipping' && reached);
        const upcoming = known && !reached && index === next;
        const soldOut = stage === 'head' ? !choices(head).length : stage === 'second' && !anyToy;
        el.classList.toggle('is-earned', Boolean(earned));
        el.classList.toggle('is-next', Boolean(upcoming && !soldOut));
        el.querySelector('[data-price]').textContent = known ? money(limits[index],currency) : money([6000,8000,12000][index],'EUR');
        el.querySelector('[data-status]').textContent = inCart ? labels.added : soldOut ? labels.sold_out
          : earned ? labels.earned : reached ? labels.available : upcoming ? labels.next : '';
      }
      const model = full && String(first.product_id) === String(car.id) ? car : quad;
      const selected = full ? model.variants.find(v => Number(v.id) === Number(first.variant_id)) : null;
      this.querySelector('[data-models]').textContent = full
        ? (model === car ? labels.car + (selected ? ' · ' + selected.title : '') : labels.quad)
        : labels.model_options;
      const picker = (unlockTop || !known) && (!full || pendingChoice);
      const claim = (unlock || !known) && !free && (skip || !known || blockedAt === key) && choices(head).length > 0;
      this.querySelector('[data-gifts]').hidden = !(picker || full || claim);
      this.querySelector('[data-picker]').hidden = !picker;
      this.querySelector('[data-claim]').hidden = !claim;
      const swap = this.querySelector('[data-switch]');
      swap.hidden = !full;
      swap.setAttribute('aria-expanded', String(Boolean(picker)));
      swap.textContent = pendingChoice ? labels.close_picker : labels.switch;
      if (picker) this.paintPicker();
      this.showNotice();
    }
  }
  customElements.define('hk-cart-rewards', Rewards);
  document.addEventListener('click', event => {
    if (!event.target.closest?.('.js-hk-remove')) return;
    event.preventDefault();
    run('remove');
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (event.defaultPrevented || !['cart','cart-drawer-form'].includes(form.id) || event.submitter?.name !== 'checkout') return;
    if (checkoutPass.has(form)) { checkoutPass.delete(form); return; }
    const panel = (form.closest('cart-drawer') || form).querySelector('hk-cart-rewards');
    const updating = form.querySelector('cart-items.pointer-events-none');
    const edited = Array.from(form.querySelectorAll('input[data-initial-value]')).find(input => input.value !== input.dataset.initialValue);
    if (updating || edited) {
      event.preventDefault();
      report('busy');
      if (edited && !updating) edited.dispatchEvent(new Event('change', {bubbles:true}));
      return;
    }
    if (!jobs && !panel && !form.querySelector('.js-hk-remove')) return;
    if (!jobs && active() && panel?.snap) {
      const state = inspect(panel.snap);
      const wanted = desired(panel.snap, state, 'checkout', 0);
      const updates = updatesFor(state.gifts, wanted);
      if ((state.free || !state.gifts.length) && !Object.keys(updates).length) return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!(await run('checkout'))) return;
    const fresh = document.getElementById(form.id);
    const button = document.querySelector('[name="checkout"][form="' + form.id + '"]') || fresh?.querySelector('[name="checkout"]');
    if (fresh && button && !button.disabled) {
      checkoutPass.add(fresh);
      button.click();
    }
  }, true);
  if (!active()) run('sync');
  window.addEventListener('pageshow', event => { if (event.persisted) run('sync'); });
})();
